import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=0b3ecbe4&"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3ecbe4')) {
      api.createRecord('0b3ecbe4', component.options)
    } else {
      api.reload('0b3ecbe4', component.options)
    }
    module.hot.accept("./ChangePasswordCard.vue?vue&type=template&id=0b3ecbe4&", function () {
      api.rerender('0b3ecbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/ChangePasswordCard.vue"
export default component.exports